import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import en from './locales/en.json'
import ro from './locales/ro.json'

import reducers from './redux/reducers'
import sagas from './redux/sagas'

export default {
  name: 'invites',
  menu: [
    {
      title: <FormattedMessage id="invites.menu.title" />,
      key: 'invites',
      icon: 'icmn icmn-qrcode',
      url: '/invites',
      roles: ['business'],
    },
  ],
  routes: [
    {
      path: '/invites',
      async lazy() {
        const Comp = await import('./pages')
        return { Component: Comp.default }
      },
      exact: true,
    },
    {
      path: '/invites/:id',
      async lazy() {
        const Comp = await import('./pages/details')
        return { Component: Comp.default }
      },
      exact: true,
    },
  ],
  locales: {
    en,
    ro,
  },
  reducers,
  sagas,
}
